export default {"src":"/_next/static/media/location.5bc61274.svg","height":22,"width":22};